"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('setShouldBlockSelection')(function setShouldBlockSelection(viewstate, shouldBlockSelection) {
    viewstate.shouldBlockSelection = shouldBlockSelection;
});
//# sourceMappingURL=setShouldBlockSelection.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/actions/setShouldBlockSelection.js
// module id = 3402
// module chunks = 2 3